import { useCallback } from "react";
import { useProjectUIStore } from "stores/projectStore";
import * as identify from "utils/treeUtils";

export const useCalculateRowHeight = (options) => {
  const showProductPictures = useProjectUIStore(
    (state) => state.showProductPictures,
  );

  const calculateRowHeight = useCallback(
    (node) => {
      if (identify.isAnyProduct(node.data) && showProductPictures) {
        return options.configurationHeight;
      }
      if (identify.isAnyProduct(node.data) && !showProductPictures) {
        return options.compactConfigurationHeight;
      }

      return options.folderHeight;
    },
    [options, showProductPictures],
  );

  return calculateRowHeight;
};
